// components/RenderPercentageTable.tsx
import { Input } from "@/shared/ui/input";

interface CreatorWithPercentage {
  id: string;
  name: string;
  percentage: number;
  displayOrder: number;
}

interface RenderPercentageTableProps {
  creators: CreatorWithPercentage[];
  onUpdatePercentage: (id: string, newPercentage: number) => void;
  readOnly?: boolean;
}

export const RenderPercentageTable = ({
  creators,
  onUpdatePercentage,
  readOnly = false,
}: RenderPercentageTableProps) => {
  const totalPercentage = creators.reduce((sum, c) => sum + c.percentage, 0);
  if (creators.length === 0) {
    return null;
  }
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-white">Porcentagem dos colaboradores</h3>

      <div className="bg-white/5 rounded-lg overflow-hidden">
        <div className="grid grid-cols-2 gap-4 p-4 bg-white/10 border-b border-white/10">
          <div className="text-white font-medium">Nome</div>
          <div className="text-white font-medium">Porcentagem da venda</div>
        </div>

        {creators.map((creator) => (
          <div
            key={creator.id}
            className="grid grid-cols-2 gap-4 p-4 border-b border-white/5 last:border-b-0"
          >
            <div className="text-white">{creator.name}</div>
            <div className="flex items-center">
              <div className="relative">
                <Input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={creator.percentage.toString()}
                  readOnly={readOnly}
                  aria-readonly={readOnly}
                  onChange={(e) => {
                    if (readOnly) return;
                    const raw = e.target.value.replace(/\D/g, "");
                    const number = Math.min(100, Math.max(0, Number(raw)));
                    onUpdatePercentage(creator.id, raw === "" ? 0 : number);
                  }}
                  className={`bg-white/[0.03] border-white/[0.06] text-white w-20 pr-8 ${readOnly ? "cursor-not-allowed opacity-70" : ""} ${creator.percentage < 0 || creator.percentage > 100
                    ? "border-red-500"
                    : ""
                    }`}
                />
                <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white/50 text-sm">
                  %
                </span>
              </div>
            </div>
          </div>
        ))}

        <div className="grid grid-cols-2 gap-4 p-4 bg-white/10 font-semibold">
          <div className="text-white">Total</div>
          <div className={totalPercentage === 100 ? "text-green-400" : "text-red-400"}>
            {totalPercentage}%
          </div>
        </div>
      </div>

      {totalPercentage !== 100 && (
        <p className="text-yellow-400 text-sm">
          ⚠️ A soma das porcentagens deve ser igual a 100%
        </p>
      )}
    </div>
  );
};
